import script from "./RegisterPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterPage.vue?vue&type=script&setup=true&lang=js"

import "./RegisterPage.vue?vue&type=style&index=0&id=3cd8c010&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cd8c010"]])

export default __exports__